import {
  NumberInput,
  coerceNumberProperty,
  coerceCssPixelValue,
} from '@angular/cdk/coercion';
import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[luiWidth]',
  standalone: true,
})
export class WidthDirective {
  @Input() get luiWidth() {
    return this._width;
  }
  set luiWidth(value: NumberInput) {
    this._width = coerceNumberProperty(value);
  }
  private _width!: number;

  @HostBinding('style.width') get widthStyle() {
    return coerceCssPixelValue(this.luiWidth);
  }

  @HostBinding('style.height') get heightStyle() {
    return 'auto';
  }
}
